import { useSelector } from "react-redux";
import { CartoLayer, colorBins } from "@deck.gl/carto";
import { selectSourceById } from "@carto/react-redux";
import { useCartoLayerProps } from "@carto/react-api";
import htmlForFeature from "utils/htmlForFeature";
import { VISUALS } from "data/config.js";

export const ZOOM_OUT_LAYER_ID = "zoomOutLayer";

export default function ZoomOutLayer() {
  const { zoomOutLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, zoomOutLayer?.source)
  );
  const zoom = useSelector((state) => state.carto.viewState.zoom);
  const visitorsOrigin = useSelector((state) => state.app.visitorsOrigin);
  const cartoLayerProps = useCartoLayerProps({
    source: source,
  });
  const breaksOrigins = useSelector((state) => state.app.breaksOrigins);

  if (source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: ZOOM_OUT_LAYER_ID,
      visible: visitorsOrigin && zoom < 8,
      getFillColor: colorBins({
        attr: VISUALS.attr,
        domain: breaksOrigins,
        colors: VISUALS.secondary_palette,
      }),
      lineWidthUnits: "pixels",
      getLineColor: [255, 255, 0],
      getLineWidth: 0,
      pickable: true,
      opacity: 0.5,
      autoHighlight: true,
      highlightColor: [71, 219, 153],
      updateTriggers: {
        getFillColor: [zoom, breaksOrigins],
        ...cartoLayerProps.updateTriggers,
      },
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ["n_visitors"],
              formatter: {
                type: "number",
                columns: ["n_visitors"],
              },
            }),
            style: {},
          };
        }
      },
    });
  }
}
